import React from 'react';
import { BrowserView } from 'react-device-detect';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Transacao from 'Interface/Transacoes';
import { useEditarTransacaoMutation } from 'View/Service/Default/Transacoes';

interface Props {
  dados: Transacao;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();

  const [editarTransacao] = useEditarTransacaoMutation();

  const cancelar = async (): Promise<void> => {
    try {
      await editarTransacao({
        id: dados.id,
        status: 2,
      }).unwrap();

      toast({
        conteudo: 'Estorno realizado com sucesso',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao estornar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3 justify-content-between">
      <div className="d-flex align-items-center w-100 position-relative">
        <div className="fs-4 text-truncate">
          {dados.descricao}
          <small className="d-block fs-6 text-muted">
            Cod. gateway: {dados.codigo_gateway}
          </small>
        </div>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="text-end fs-4">
          {dados.status == 0 && <Icone nome="x-circle" className="text-danger" />}
          {dados.status == 1 && (
            <Icone nome="cash-coin" className="text-success" />
          )}
          {dados.status == 2 && (
            <Icone nome="arrow-clockwise" className="text-warning" />
          )}
        </div>
        <div className="ms-5 fs-5 text-end text-nowrap">
          {dados.criado.data().toLocaleString()}
          <small className="d-flex fs-6 text-muted justify-content-end">
            <Icone nome="calendar" className="me-2" />
            Registrado em
          </small>
        </div>
        {dados.status == 1 && (
          <div className="ms-5 text-end">
            <Botao
              tema="danger"
              onClick={cancelar}
              icone="arrow-counterclockwise"
              confirmacao="Tem certeza que deseja fazer o estorno desse pagamento?"
            />
          </div>
        )}
      </BrowserView>
    </div>
  );
};

export default Lista;
